import { GridContainer, GridContainerName } from "../../../interfaces/IGridSettings";
import AffectedCustomersContainer from "../AffectedEntitiesComponents/AffectedEntitiesContainer";
import AlertContainer from "../AlertComponents/AlertContainer";
import DetailsContainer from "../DetailsComponents/DetailsContainer";
import MapContainer from "../MapComponents/MapContainer";
import PostContainer from "../PostComponents/PostContainer";
import DocumentContainer from "../DocumentComponents/DocumentContainer";
import { EventDto } from "../../../interfaces/IEvent";
import { Grid } from "@mui/material";
import AssignmentContainer from "../AssignmentComponents/AssignmentContainer";

interface IncidentContainersProps {
    container: GridContainer;
    index: number;
    viewEvent: EventDto;
    handleGetEvent: (eventId: string | undefined) => void;
};

export default function IncidentContainers ({ container, index, viewEvent, handleGetEvent }: IncidentContainersProps) {
    const containers: any = {
        [GridContainerName.detailsContainer]: <DetailsContainer key={index} viewEvent={viewEvent} onUpdateEventView={handleGetEvent} />,
        [GridContainerName.affectedCustomersContainer]: <AffectedCustomersContainer key={index} viewEvent={viewEvent} />,
        [GridContainerName.alertContainer]: <AlertContainer key={index} viewEvent={viewEvent} onUpdateEventView={handleGetEvent} />,
        [GridContainerName.mapContainer]: <MapContainer key={index} viewEvent={viewEvent} />,
        [GridContainerName.postContainer]: <PostContainer key={index} eventId={viewEvent?.id} eventPosts={viewEvent?.eventPosts} onUpdateEventView={handleGetEvent} />,
        [GridContainerName.documentContainer]: <DocumentContainer key={index} viewEvent={viewEvent} />,
        [GridContainerName.assignmentContainer]: <AssignmentContainer key={index} viewEvent={viewEvent} onUpdateEventView={(eventId: string) => Promise.resolve(handleGetEvent(eventId))} />
    }

    return (containers[container.name] ? <Grid key={index} size={container.width}>
                {containers[container.name]}
            </Grid> : null);
};